import { z } from '../zod.js';

/**
 * The `orderBumps` field of a checkout submission — the first client-sent
 * product reference, and so the first zod-validated part of a checkout body.
 * Scoped to this field only: the rest of the body is still spread raw.
 *
 * Shape only. Whether an id is actually an offer on the page, and whether the
 * quantity is one the placement allows, is the server's guard chain
 * (`assertValidOrderBumpSubmission`).
 */
export const OrderBumpSubmissionValidationSchema = z
  .array(
    z.object({
      productId: z.string().regex(/^[a-f\d]{24}$/i),
      quantity: z.number().int().min(1).max(999),
      // Minor units, and only meaningful on a pay-what-you-want bump. Whether
      // one is required, and whether it clears the placement's minimum, is the
      // server's guard chain — this only pins the shape.
      payWhatYouWantAmount: z.number().int().min(0).optional(),
    }),
  )
  .max(20);

export type OrderBumpSubmission = z.infer<typeof OrderBumpSubmissionValidationSchema>;
